import { apiV2 } from "../axiosInstance";

function getSuppliers() {
    return apiV2.get(`suppliers`);
}

export { getSuppliers }